import React from 'react';
import { useState } from 'react';
import styled from 'styled-components';
import { borrowLender } from '../../services/pooldata';
import { poolAvailable } from '../../services/tokenData';

const StyledTable = styled.table`
  caption-side: top;
  border: none;
  border-collapse: collapse;
  /* border-collapse: separate; */
  /* border-spacing: 5px 10px; */

  caption-side: bottom;
  /* empty-cell: show | hide;  */
  /* empty-cell is a property of table or the cells themselves */

  /* vertical-align: baseline | sub | super | text-top | 
                text-bottom | middle | top | bottom | 
                <percentage> | <length> */

  /* tbody {
    vertical-align: top;
  }              */
  td,
  th {
    border: 1px solid black;
  }
  /* td,
  th {
    border: 1px solid;
  } */

  td {
    padding: 10px 15px;
  }

  tbody tr {
    :nth-of-type(odd) {
      background-color: #efefef;
    }
    :nth-of-type(even) {
      background-color: #efefef;
    }
    :hover {
      background-color: lightpink;
    }
  }
  thead > tr {
    background-color: #c2c2c2;
  }
  caption {
    font-size: 0.9em;
    padding: 5px;
    font-weight: bold;
  }
`;

export default ({ data, uV2Core, uWeb3, poolContract, unilendV2poolABI }) => {
  const [val, setVal] = useState({});
  const callEvent = async (event) => {
    const result =
      event === 'Lend' || event === 'Borrow'
        ? (await borrowLender(poolContract, event))
          : event === 'PoolCreated'
          ? (await borrowLender(uV2Core, event))
          // : event === 'TotalAvailable'
          : await poolAvailable(uV2Core, unilendV2poolABI, uWeb3);
    let payload = {
      ...val,
      [event]: result,
    };
    setVal(payload);
  };

  return (
    <TableMarkup
      titles={Object.keys(data[0])}
      data={data}
      poolContract={poolContract}
      uWeb3={uWeb3}
      uV2Core={uV2Core}
      callEvent={callEvent}
      val={val}
    />
  );
};

const TableMarkup = ({
  titles,
  data,
  uV2Core,
  uWeb3,
  poolContract,
  callEvent,
  val,
}) => (
  <StyledTable>
    <colgroup>
      <col />
      <col />
      <col />
    </colgroup>
    <thead>
      <tr>
        {titles.map((title, index) => (
          <th key={index}>{title}</th>
        ))}
      </tr>
    </thead>
    <tbody>
      {data.map((item, i) => (
        <tr key={i}>
          {titles.map((title, index) => {
            if (index === 1) {
              return (
                <td key={index}>
                  <button onClick={() => callEvent(item[title])}>
                    Get Data
                  </button>
                </td>
              );
            } else if (index === 2) {
              return <td key={index}>{val[item.Call] || 'Call Event'}</td>;
            } else {
              return <td key={index}>{item[title]}</td>;
            }
          })}
        </tr>
      ))}
    </tbody>
  </StyledTable>
);
